export const sumArrayOfNumbers = (num: number[]) => {
  return num.reduce((acc, curr) => acc + curr, 0);
};
